<template>
  <div id="app">
    <router-view />

    <SvgSprite />
  </div>
</template>

<script>
import '@/assets/sass/style.scss'
import SvgSprite from './components/SvgSprite'

export default {
  name: 'App',
  components: {
    SvgSprite
  }
}
</script>

<style>
#app {
  font-family: Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #57585a;
  height: 100%;
  min-height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/App.vue